// extracted by mini-css-extract-plugin
module.exports = {"AccountInfoSpace":"AccountInfoSpace_DK7bc"};